import { render } from "./MWContactPage.vue?vue&type=template&id=441f588d&scoped=true"
import script from "./MWContactPage.vue?vue&type=script&lang=js"
export * from "./MWContactPage.vue?vue&type=script&lang=js"

import "./MWContactPage.vue?vue&type=style&index=0&id=441f588d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441f588d"]])

export default __exports__